import { render } from "./ArgonSelect.vue?vue&type=template&id=f25dd3fc"
import script from "./ArgonSelect.vue?vue&type=script&lang=js"
export * from "./ArgonSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__